import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/system/Unstable_Grid';
import { Button } from '@mui/material';
import SectionTitle from '../../../components/SeccionTitle';
import { reporteAsistenciaa } from '../../../assets/js/reportes';
import './styles.scss';

export default function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {}, []);

  return (
    <>
      <div className='content-area'>
        <SectionTitle title='Dashboard' />
        <section id='dashboard'>
          <Grid container direction='row' spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <div className='center container-reports'>
                <div className='title-module'>Reportes</div>
                <Grid container direction='row' spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Button className='btn' style={{ color: '#fff' }} onClick={() => reporteAsistenciaa('Abril')}>
                      Descargar Reporte asistencia
                    </Button>
                    <input id={`text5`} value='' />
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </section>
      </div>
    </>
  );
}
